import api from '@/services/api'
import { AxiosRequestConfig } from 'axios'
import {
  CreatePasswordPayload,
  CreatePasswordConexaResponse,
  MagicLinkGeneratorResponse,
} from './types'

class SignUpService {
  static async createPassword(
    patientId: string,
    createPasswordPayload: CreatePasswordPayload,
    config?: AxiosRequestConfig,
  ): Promise<CreatePasswordConexaResponse> {
    const { data } = await api.post(
      `/integration/ativacao/paciente/v2/${patientId}/cadastrar-senha`,
      createPasswordPayload,
      config,
    )

    return data
  }

  static async modifyPassword(
    password: string,
    confirmPassword: string,
    config: AxiosRequestConfig,
  ): Promise<Record<string, string>> {
    const { data } = await api.post(
      '/integration/app-paciente/usuario/modificar-senha',
      {
        senha: password,
        csenha: confirmPassword,
      },
      config,
    )
    return data
  }

  static async getMagicLink(): Promise<MagicLinkGeneratorResponse> {
    const token = sessionStorage.getItem('token')
    const { data } = await api.get(
      `/integration/ativacao/paciente/v2/${token}/gerar-link-magico`,
    )

    return data
  }
}
// integration/ativacao/paciente/${token}/gerar-link-magico

export default SignUpService
